module.exports = __webpack_public_path__ + "static/media/E21.14d4472a.png";